module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("fes49"))).then(() => parcelRequire('d0iPb'));